import { Component, OnInit } from '@angular/core';
import { EarningHandlerComponent } from './earning.handler';
import { AgentService } from 'src/app/agent/services/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sym-earning',
  templateUrl: './earning.component.html',
  styleUrls: ['./earning.component.scss'],
})
export class EarningComponent extends EarningHandlerComponent implements OnInit {
  public dateTimeRange1: Date[];
  constructor(
    public agentService: AgentService,
    public route: ActivatedRoute,
    public router: Router,
    public settingService: SettingService,
    private modalService: NgbModal,
    calendar: NgbCalendar
  ) {
    super(agentService, settingService, router);
  }
}
